import type { FaireBrandEntity } from "../../entity_types/brand";

export const viverano_organics: FaireBrandEntity = {
  token: "viverano-organics",
  type: "brand",
  name: "Viverano Organics",
  location: "Las Vegas, NV",
  minimumOrderDollars: 150,
  rating: 5,
  isTopShop: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "parity-fix",
  },
};
